"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReworkType = void 0;
exports.ReworkType = {
    FOLDING: "FOLDING",
    STAIN_REMOVAL: "STAIN_REMOVAL",
    LABELLING: "LABELLING",
};
//# sourceMappingURL=rework-type.js.map